import React from 'react';
import { bool, shape, string } from 'prop-types';

const SpareParts = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15 8H13V9H16V11H18V12.8389L19.2793 9H23V22H19.1807L18.6807 19.5H17.5352L16.5352 21H6.46484L4 17.3027V16H3V18H1V12H3V14H4V9H7V8H5V3H15V8ZM6 16.6973L7.53516 19H15.4648L16.4648 17.5H20.3193L20.8193 20H21V11H20.7207L19.2207 15.0078H16V13H14V11H6V16.6973ZM9 8V9H11V8H9ZM7 6H13V5H7V6Z" fill="currentColor" />
  </svg>
);

SpareParts.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default SpareParts;
